'use es6';

import { createSelector } from 'reselect';
import { gate } from 'hub-http/gates';
import { debugGate } from '../utils/env';
const getGates = state => state.auth.gates;
const getPortal = state => state.auth.portal;
const getUser = state => state.auth.user;
export const selectPortalScopes = state => state.auth.portal.scopes;
export const selectUserScopes = state => state.auth.user.scopes;
export const getAuth = state => state.auth;
const getIsUngated = createSelector([getGates], gates => gateName => gates.includes(gateName) || debugGate(gateName));
export const getIsCustomer = createSelector([getPortal], portal => !!(portal && portal.portal_id));
export const getIsPublic = createSelector([getIsCustomer], isCustomer => !isCustomer);
export const getUserFirstName = createSelector([getUser], user => user.first_name);
export const getUserLastName = createSelector([getUser], user => user.last_name);
export const getUserEmail = createSelector([getUser], user => user.email);
export const getUserId = createSelector([getUser], user => user.user_id);
export const getHasZorseWebticketScope = createSelector([selectUserScopes], scopes => scopes.includes('zorse-webticket'));
export const getIsUngatedForUnifiedDetails = createSelector([getIsUngated], isUngated => isUngated(gate('Marketplace:UnifiedDetails')));